import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  Modal,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import jobRoleImage from "../../assets/images/unsplash_O453M2Liufs.png";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useTMutation } from "../../utils/useTMutation";
import { update } from "../../slice/jobSlice";
import { useNavigate } from "react-router-dom";
import ReplyIcon from "@mui/icons-material/Reply";
import showToast from "../Hot-Toast/showToast";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import CloseIcon from "@mui/icons-material/Close";

import RenderStatusJobCard from "../../pages/CommonViewPages/RenderStatusJobCard";
import { setSelectedCard } from "../../slice/selectedJobCardSlice";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import DataTable from "react-data-table-component";
import { JobtTimeSheet } from "../JobTimeSheet/JobTimeSheet";
import { fontSize } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
import { useCallback } from "react";
import { formatDateAndTime, formatDateAndTimeUTC } from "../../utils/genericMethod";
import { useTQuery } from "../../utils/useTQuery";
import { getAllCliniciansDocumentsPath } from "../../utils/clinicialAPI";
import { API_URL, FRONTEND_URL } from "../../appConstants";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
  maxHeight: "535px",
  overflowY: "auto",
};

export default function JobCardDetails({ onSaved, data }) {
  console.log("data", data);
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);
  const { selectedCard } = useSelector((state) => state.selectedJob);
  const { selectedTabData } = useSelector((state) => state.profileTabSection);
  const { controlBy, controlAction, controlUser } = useSelector(
    (state) => state.user,
  );

  // console.log("selectedCard", selectedCard);
  const InterviewDate = selectedCard?.cliniciansInFacilityJobShifts?.[0]
    ?.interviewDateTime
    ? formatDateAndTimeUTC(
        selectedCard?.cliniciansInFacilityJobShifts?.[0]?.interviewDateTime,
      )
    : "";
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [openTimeSheetPopup, handleCancel] = useState(false);
  const [clinicianStatus, setClinicianStatus] = useState(
    selectedCard?.cliniciansInFacilityJobShifts?.[0]?.clinicianStatus || "",
  );
  const [offerStatus, setOfferStatus] = useState(
    selectedCard?.cliniciansInFacilityJobShifts?.[0]?.offerStatus || "No Offer",
  );
  const [saved, setSaved] = useState();
  const [jobScheduleExists, setJobScheduleExists] = useState(false);
  useEffect(() => {
    setSaved(data?.save_jobs?.[0]?.SAVED);
  }, [data?.save_jobs?.[0]?.SAVED]);

  const {
    data: scheduleExists,
    refetch: refetchSchedule,
    isLoading: loadingSchedule,
  } = useTQuery(
    ["scheduleExists", data?.ID], // query key
    `schedule/fetchShiftDetailsByJobId?${new URLSearchParams({
      ID: data?.ID,
    }).toString()}`,
    "get",
    {},
    !!data?.ID,
  );

  const { data: isRequiredData, refetch: isRequiredDataRefetch } = useTQuery(
    ["isRequiredData", data?.ID], // query key
    `job/fetchMiscellaneousDocumentsByJobId?${new URLSearchParams({
      jobId: data?.ID,
      clinicianId: userDetails?.ID,
    }).toString()}`,
    "get",
    {},
    !!data?.ID,
  );
  console.log(isRequiredData, "isRequiredData");

  const roleSpecialtyIds = selectedTabData?.specialities
    ?.map((speciality) => speciality?.SPECIALTY_ID)
    ?.filter((id) => id); // filter out null/undefined values if any

  // ✅ Convert array to comma-separated string
  const ROLE_ID = roleSpecialtyIds?.join(",");
  const { data: certificationDocuments, refetch } = useQuery({
    queryKey: ["certificationDocuments"],
    queryFn: () =>
      getAllCliniciansDocumentsPath(
        ROLE_ID,
        controlBy === "facility" || controlBy === "admin"
          ? controlUser
          : userDetails?.ID,
      ),
    enabled: !!ROLE_ID,
    // staleTime: 1000 * 60 * 2,
  });

  const [openDocumentModal, setOpenDocumentModal] = useState(false);
  const [currentDocumentUrl, setCurrentDocumentUrl] = useState(null);

  const handleOpenDocument = (docPath) => {
    setCurrentDocumentUrl(`${API_URL}user/viewFile?fileName=${docPath}`);
    setOpenDocumentModal(true);
  };

  const handleCloseDocument = () => {
    setOpenDocumentModal(false);
    setCurrentDocumentUrl(null);
  };

  useEffect(() => {
    if (scheduleExists?.STATUS) {
      setJobScheduleExists(scheduleExists.OUTPUT); // true or false
    }
  }, [scheduleExists]);

  useEffect(() => {
    if (data?.ID) {
      refetchSchedule();
    }
  }, [data?.ID]);

  const [showModel, setShowModel] = useState(false);
  const [jobStatusDetail, setJobstatusDetail] = useState("");
  const [openPopup, handlePopupClose] = useState(false);

  const [open, setOpen] = useState(false);

  const setShowModel1 = () => {
    dispatch(setSelectedCard({ ...selectedCard, showModal1: true }));
  };

  useEffect(() => {
    if (
      selectedCard?.cliniciansInFacilityJobShifts?.[0]?.clinicianStatus ===
      "Interested"
    ) {
      setClinicianStatus(
        selectedCard?.cliniciansInFacilityJobShifts?.[0]?.clinicianStatus,
      );
    }
  }, [selectedCard]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleUpdateClinicianStatus = (data) => {
    const updatedJob = {
      ...selectedCard,
      cliniciansInFacilityJobShifts: [data],
    };
    dispatch(setSelectedCard(updatedJob));
  };

  const saveJobMutation = useTMutation(
    "/job/saveAndRemoveJob",
    "post",
    (response) => {
      if (response?.STATUS) {
        return response;
      }
    },
  );

  const handleSaveJob = useCallback(
    async (cardID) => {
      // setSaved(!saved)
      const response = await saveJobMutation.mutateAsync({
        USER_ID: userDetails?.ID,
        JOB_ID: cardID,
      });

      if (response.STATUS) {
        if (onSaved) {
          if (selectedCard?.save_jobs?.length) {
            const updatedJob = {
              ...selectedCard,
              save_jobs: selectedCard.save_jobs.map((job, idx) =>
                idx === 0
                  ? {
                      ...job,
                      SAVED: response?.OUTPUT?.SAVED == true ? true : false,
                    }
                  : job,
              ),
            };
            // isJobSaved = updatedJob?.save_jobs[0]?.SAVED
            dispatch(
              setSelectedCard({
                ...selectedCard,
                save_jobs: selectedCard.save_jobs.map((job, idx) =>
                  idx === 0
                    ? {
                        ...job,
                        SAVED: response?.OUTPUT?.SAVED == true ? true : false,
                      }
                    : job,
                ),
              }),
            );
            setSaved(updatedJob?.save_jobs?.[0]?.SAVED);
            // dispatch(setSelectedCard());
            onSaved();
          }
          // onSaved();
        }
      }
    },
    [saveJobMutation, userDetails, onSaved, selectedCard],
  );

  const checkStatus = async (value) => {
    // return;

    if (value === "Hired") {
      dispatch(update({ ...selectedCard, MODE: "Edit" }));
      navigate("/clinician/offersaccepted", { state: "Edit" });
      setJobstatusDetail("OfferAccepted");
    } else if (
      value === "Interested" ||
      value === "Accepted" ||
      value === "Declined"
    ) {
      const response = await jobCardActionSubmit.mutateAsync({
        USER_ID: userDetails?.ID,
        JOB_ID: selectedCard?.ID,
        STATUS: value,
      });

      if (response?.STATUS) {
        showToast("success", response?.MESSAGE);
        await handleUpdateClinicianStatus(response?.OUTPUT);
        // setOpenModal(true);
      } else {
        showToast("error", response?.MESSAGE || "Nothing happened", 3000);
      }
    } else {
      showToast("error", "you're clicked not working right now.");
    }
  };

  const jobCardActionSubmit = useTMutation(
    "/job/saveAndRemoveJob",
    "post",
    (response) => {
      if (response.STATUS) {
        return response;
      }
    },
  );

  const timesheetMutation = useTMutation(
    "/job/addJobTimesheet",
    "post",
    (response) => {
      if (response.STATUS) {
        refetchSchedule();
        showToast("success", "Timesheet recorded successfully");
        return response;
      } else {
        showToast("error", response?.MESSAGE || "Failed to record timesheet");
      }
    },
  );

  const workingDaysData = selectedCard?.SERVICE_DURATION?.length
    ? selectedCard.SERVICE_DURATION?.map(
        (data) =>
          `${data?.JOB_DAY}: ${data?.JOB_IN_TIME} - ${data?.JOB_OUT_TIME}`,
      )
    : selectedCard?.JOB_SERVICE_WITH_DAY_TIME?.length
      ? [
          `${selectedCard?.JOB_SERVICE_WITH_DAY_TIME?.[0]?.JOB_DAY} - ${
            selectedCard?.JOB_SERVICE_WITH_DAY_TIME[
              selectedCard?.JOB_SERVICE_WITH_DAY_TIME.length - 1
            ]?.JOB_DAY
          }`,
        ]
      : [];

  const jobDetailsUI = [
    {
      title: "Speciality:",
      data: selectedCard?.specialty?.SPECIALTY_NAME,
    },

    {
      title: "Shift Type:",
      data: selectedCard?.SERVICE_TYPE,
    },
    {
      title: "Start Date:",
      data: new Date(selectedCard?.SERVICE_DATE).toDateString(),
    },
    {
      title: "End Date:",
      data: new Date(selectedCard?.SERVICE_END_DATE).toDateString(),
    },
    // {
    //   title: "Working Days:",
    //   // data: data?.SERVICE_TYPE == "Recurring" ? data.job_services :"",
    // },
    // {
    //   title: "Time:",
    //   // data: "07:00 - 15:30",
    //   // data: selectedCard?.SERVICE_DURATION?.[0]?.JOB_IN_TIME  - selectedCard?.SERVICE_DURATION?.[0]?.JOB_OUT_TIME    ,
    //   data: `${selectedCard?.SERVICE_DURATION?.[0]?.JOB_IN_TIME}  - ${selectedCard?.SERVICE_DURATION?.[0]?.JOB_OUT_TIME }`   ,

    // },
    // {
    //   title: "Working Days:",
    //   data: selectedCard?.SERVICE_DURATION?.length
    //     ? selectedCard.SERVICE_DURATION.map(
    //         (data) => `${data.JOB_DAY}: ${data.JOB_IN_TIME} - ${data.JOB_OUT_TIME}`
    //       ).join(", ") // Format: "Monday: 07:00 - 15:30, Tuesday: 09:00 - 17:00"
    //     : selectedCard?.JOB_SERVICE_WITH_DAY_TIME?.length
    //     ? `${selectedCard.JOB_SERVICE_WITH_DAY_TIME[0]?.JOB_DAY} - ${
    //         selectedCard.JOB_SERVICE_WITH_DAY_TIME[selectedCard.JOB_SERVICE_WITH_DAY_TIME.length - 1]?.JOB_DAY
    //       }`
    //     : "N/A", // Default text if no data exists
    // {
    //   title: "Working Days:",
    //   data: workingDaysData?.length ? (
    //     <Typography
    //       variant="body2"
    //       sx={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
    //       onClick={handleOpen}
    //     >
    //       View Working Days
    //     </Typography>
    //   ) : (
    //     "-"
    //   ),
    // },
    // },
    ...(selectedCard?.SERVICE_TYPE !== "Recurring"
      ? [
          {
            title: "Time:",
            data: `${selectedCard?.JOB_IN_TIME} - ${selectedCard?.JOB_OUT_TIME}`,
          },
        ]
      : []),
    {
      title: "Location:",
      // data: "Glendora",
      data: selectedCard?.facility_addlocation?.streetAddress,
    },
    {
      title: "Pay:",
      // data: `$${selectedCard?.PAY_AMOUNT_FROM}-$${selectedCard?.PAY_AMOUNT_TO}/hr`,
      data: selectedCard?.cliniciansInFacilityJobShifts?.[0]
        ? `$${selectedCard.cliniciansInFacilityJobShifts?.[0]?.clinicianPayRate}/hr`
        : `$${selectedCard?.PAY_AMOUNT_FROM}-$${selectedCard?.PAY_AMOUNT_TO}/hr`,
      // data: "$50-$60",
    },
  ];

  const jobId = data?.ID;
  // useEffect(() => {
  //   console.log("jobId =>", jobId); // ⬅️ Debug line
  //   if (jobId?.ID) {
  //     fetchJobScheduleMutation.mutate({ ID: jobId?.ID });
  //   }
  // }, [jobId?.ID]);

  const uploadDocumentMutation = useTMutation(
    "/job/uploadMiscellaneousDocument",
    "post",
    (response) => {
      if (response?.STATUS) {
        refetchSchedule();
        refetch();
        isRequiredDataRefetch();
        showToast("success", response?.MESSAGE);
        return response;
      } else {
        showToast("error", response?.MESSAGE);
      }
    },
  );

  const handleUpload = (doc) => {
    // Create a hidden file input dynamically
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*,.pdf,.doc,.docx";
    input.style.display = "none";

    // When a file is selected
    input.onchange = async (event) => {
      const file = event.target.files[0];
      if (!file) return; // no file selected

      // Create FormData to send file + metadata
      const formData = new FormData();
      formData.append("USER_ID", userDetails?.ID);
      formData.append("MISCELLANEOUS_DOCUMENT_ID", doc?.ID); // Assuming `doc` has an ID
      formData.append("file", file);

      // First upload to backend
      await uploadDocumentMutation.mutateAsync(formData);
      // Then update Redux
      dispatch(
        setSelectedCard({
          ...selectedCard,
          selectedDocument: doc,
          selectedFile: file,
          showUploadModal: true,
        }),
      );
    };

    // Trigger click to open file picker
    document.body.appendChild(input);
    input.click();

    // Remove from DOM after use
    input.remove();
  };

  return (
    <>
      <Grid>
        <Box px={3}>
          <Card>
            <Grid
              container
              alignItems="center"
              spacing={1}
              justifyContent="space-around"
              px={3}
              pt={2}
            >
              <Grid
                item
                xs={12}
                sm={12}
                display="flex"
                justifyContent={"space-between"}
              >
                <Box>
                  <img src={jobRoleImage} alt="jobRole" />
                </Box>

                <Box>
                  <Tooltip title="Save Job">
                    <BookmarkBorderOutlinedIcon
                      key={saved}
                      style={{
                        background: saved
                          ? "linear-gradient(to right,#6ebe44,#4eb3e8)"
                          : "",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSaveJob(selectedCard?.ID);
                      }}
                    />
                  </Tooltip>

                  <Tooltip title="Share">
                    <IconButton
                      style={{ transform: "scaleX(-1)", cursor: "pointer" }}
                      onClick={setShowModel1}
                    >
                      <IconButton
                        style={{ transform: "scaleX(-1)" }}
                        onClick={setShowModel1}
                      >
                        <ReplyIcon />
                      </IconButton>
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography
                  className="montserratFont"
                  sx={{
                    fontSize: "18px",
                    color: "rgba(0,0,0,0.87)",
                    fontWeight: 700,
                  }}
                >
                  {selectedCard?.jobs_role?.ROLE_NAME}
                </Typography>

                <Box
                  sx={{
                    width: "auto",
                    alignItems: "center",
                    display: "flex",
                    fontWeight: 400,

                    marginTop: "10px",
                  }}
                >
                  <WorkOutlineOutlinedIcon
                    sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }}
                  />
                  <Typography
                    sx={{ fontSize: "14px", color: "rgba(0,0,0,0.6)" }}
                    ml={1}
                  >
                    {selectedCard?.JOB_TYPE}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                    margin: "auto",
                    fontWeight: 400,
                    marginBottom: "10px",
                  }}
                >
                  <MonetizationOnOutlinedIcon
                    sx={{ color: "rgba(0,0,0,0.6)", fontSize: "16px" }}
                  />
                  <Typography
                    ml={1}
                    sx={{
                      fontSize: "14px",
                      color: "rgba(0,0,0,0.6)",
                      fontWeight: 400,
                    }}
                  >{`$${selectedCard?.PAY_AMOUNT_FROM}-$${selectedCard?.PAY_AMOUNT_TO}/hr`}</Typography>
                </Box>
                {InterviewDate && clinicianStatus === "Interview" && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                      margin: "auto",
                      fontWeight: 400,
                      marginBottom: "10px",
                    }}
                  >
                    Interview Date & Time:&nbsp;
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "rgba(255, 123, 0, 0.92)",
                        fontWeight: 600,
                      }}
                    >
                      {InterviewDate}
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Grid>

            {/*  {jobScheduleExists !== false && (
              <Grid item p={3}>
                <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                  {selectedCard?.jobsheet == true ||
                    (clinicianStatus === "Hired" &&
                      offerStatus === "OfferAccepted") ? (
                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "#6ebe44" }}
                      type="submit"
                      onClick={() => {
                        //  checkStatus("Interested");
                        handleCancel(true);
                      }}
                    >
                      Add Job Time Sheet
                    </Button>
                  ) : (
                    <RenderStatusJobCard
                      hiringType={selectedCard?.HIRING_TYPE}
                      clinicianStatus={clinicianStatus}
                      offerStatus={offerStatus}
                      checkStatus={checkStatus}
                    />
                  )}
                </Box>
              </Grid>
            )} */}

            <Grid item p={3}>
              <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                {selectedCard?.jobsheet === true ||
                (clinicianStatus === "Hired" &&
                  offerStatus === "OfferAccepted") ? (
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#6ebe44" }}
                    type="submit"
                    onClick={() => handleCancel(true)}
                  >
                    Add Job Time Sheet
                  </Button>
                ) : (
                  <RenderStatusJobCard
                    hiringType={selectedCard?.HIRING_TYPE}
                    clinicianStatus={clinicianStatus}
                    offerStatus={offerStatus}
                    checkStatus={checkStatus}
                    disable={isRequiredData?.OUTPUT}
                  />
                )}
              </Box>
            </Grid>
            <hr
              style={{
                marginTop: "20px",
                color: "#000000",
                opacity: "60%",
                width: "90%",
                margin: "0 auto",
              }}
            />

            <Grid container direction="column" spacing={1} px={3} pt={2}>
              <Grid
                item
                xs={12}
                sm={12}
                display="flex"
                justifyContent="space-between"
              >
                <Typography
                  variant="h3"
                  className="montserratFont"
                  style={{
                    fontWeight: 600,
                    fontSize: "20px",
                    color: "#000000",
                    opacity: "87%",
                  }}
                >
                  Job Details
                </Typography>
              </Grid>
              {jobDetailsUI?.map((dtaUi) => {
                return (
                  <Grid item lg={12}>
                    <Box display="flex">
                      <Typography
                        className="montserratFont"
                        variant="h4"
                        sx={{
                          fontWeight: 510,
                          fontSize: "16px",
                          color: "#000000",
                          opacity: "87%",
                          minWidth: "140px", // Ensures consistent spacing
                        }}
                      >
                        {dtaUi?.title}
                      </Typography>
                      <Typography
                        variant="h6"
                        className="loraFont"
                        sx={{
                          fontWeight: 400,
                          fontSize: "14px",
                          color: "#000000",
                          opacity: "60%",
                        }}
                      >
                        {dtaUi?.data}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>

            <Grid
              container
              alignItems="center"
              spacing={1}
              justifyContent="space-around"
              p={3}
              pb={3}
            >
              <Grid
                item
                xs={12}
                sm={12}
                display="flex"
                justifyContent="space-between"
              >
                <Typography
                  variant="h3"
                  className="montserratFont"
                  style={{
                    fontWeight: 600,
                    fontSize: "20px",
                    color: "#000000",
                    opacity: "87%",
                  }}
                >
                  Job Description
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography
                  id="delete-modal-title"
                  className="loraFont"
                  variant="h6"
                  component="h2"
                  style={{
                    fontWeight: 400,
                    fontSize: "16px",
                    color: "#000000",
                    opacity: "60%",
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: selectedCard?.JOB_DESCRIPION,
                    }}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} mt={3}>
                <Box display="flex" justifyContent="space-between">
                  <Typography
                    variant="h3"
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "#000000",
                      opacity: "87%",
                    }}
                    px={0.5}
                  >
                    Responsibilities:
                  </Typography>
                </Box>

                <Typography px={0.5} pt={1}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: selectedCard?.JOB_RESPONSIBILITY,
                    }}
                  />
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} mt={3}>
                <Box display="flex" justifyContent="space-between">
                  <Typography
                    variant="h3"
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "#000000",
                      opacity: "87%",
                    }}
                    px={0.5}
                  >
                    Required Documents:
                  </Typography>
                </Box>

                <>
                  <Box px={0.5} pt={1}>
                    {isRequiredData?.OUTPUT?.map((doc) => {
                      const matchedDoc =
                        certificationDocuments?.OUTPUT?.miscellaneousDocuments?.find(
                          (cDoc) =>
                            cDoc.DOCUMENT_NAME?.toLowerCase() ===
                            doc.DOCUMENT_NAME?.toLowerCase(),
                        );

                      const isPdf =
                        matchedDoc?.DOCUMENT_PATH?.toLowerCase().endsWith(
                          ".pdf",
                        );

                      return (
                        <Box
                          key={doc.ID}
                          display="flex"
                          flexDirection="column"
                          borderBottom="1px solid #ddd"
                          py={1}
                        >
                          {/* Top row with name + action */}
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Typography
                              style={{ fontSize: "14px", color: "#333" }}
                            >
                              {doc.DOCUMENT_NAME.replace(/_/g, " ")}
                              {doc.IS_REQUIRED &&
                                (!doc.miscellaneous_Document ||
                                  doc.miscellaneous_Document.length === 0) && (
                                  <span style={{ color: "red", marginLeft: 4 }}>
                                    *
                                  </span>
                                )}
                            </Typography>

                            {matchedDoc ? (
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => {
                                  // toggle visibility by storing docId in state if needed
                                  setCurrentDocumentUrl((prev) =>
                                    prev === matchedDoc.DOCUMENT_PATH
                                      ? null
                                      : matchedDoc.DOCUMENT_PATH,
                                  );
                                }}
                              >
                                👁 View
                              </Button>
                            ) : (
                              <Button
                                variant="outlined"
                                size="small"
                                disabled={
                                  uploadDocumentMutation.isLoading ||
                                  uploadDocumentMutation.isPending
                                }
                                onClick={() => handleUpload(doc)}
                              >
                                upload
                              </Button>
                            )}
                          </Box>

                          {/* Inline document preview */}
                          {currentDocumentUrl === matchedDoc?.DOCUMENT_PATH && (
                            <>
                              {console.log(
                                "DOC PATH =>",
                                `${FRONTEND_URL}uploads/${matchedDoc.DOCUMENT_PATH}`,
                              )}
                              <Box mt={1}>
                                {isPdf ? (
                                  <iframe
                                    src={`${FRONTEND_URL}uploads/${matchedDoc.DOCUMENT_PATH}`}
                                    width="100%"
                                    height="400px"
                                    style={{ border: "1px solid #ccc" }}
                                    title="PDF Document"
                                  />
                                ) : (
                                  <img
                                    src={`${FRONTEND_URL}uploads/${matchedDoc.DOCUMENT_PATH}`}
                                    alt="document"
                                    style={{
                                      width: "100%",
                                      maxHeight: "400px",
                                      objectFit: "contain",
                                      border: "1px solid #ccc",
                                    }}
                                  />
                                )}
                              </Box>
                            </>
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                </>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Grid>

      {open && (
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle style={{ fontSize: "14px" }}>Working Days</DialogTitle>
          <DialogContent>
            <List>
              {workingDaysData?.map((day, index) => (
                <ListItem key={index}>{day}</ListItem>
              ))}
            </List>
          </DialogContent>
        </Dialog>
      )}

      {openModal && (
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="delete-modal-title"
          aria-describedby="delete-modal-description"
        >
          <Card sx={style}>
            <Box>
              <Typography
                id="delete-modal-title"
                variant="h6"
                component="h2"
                margin={2}
                sx={{ textAlign: "center" }}
              >
                {/* <BlockIcon color="error" fontSize='large' /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="100"
                  height="100"
                  viewBox="0 0 48 48"
                >
                  <linearGradient
                    id="5zzMGVQnN_QyRYWGmJUsQa_A8xKzsTKHhzn_gr1"
                    x1="9.858"
                    x2="38.142"
                    y1="9.858"
                    y2="38.142"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0" stop-color="#21ad64"></stop>
                    <stop offset="1" stop-color="#088242"></stop>
                  </linearGradient>
                  <path
                    fill="url(#5zzMGVQnN_QyRYWGmJUsQa_A8xKzsTKHhzn_gr1)"
                    d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
                  ></path>
                  <path
                    d="M32.172,16.172L22,26.344l-5.172-5.172c-0.781-0.781-2.047-0.781-2.828,0l-1.414,1.414	c-0.781,0.781-0.781,2.047,0,2.828l8,8c0.781,0.781,2.047,0.781,2.828,0l13-13c0.781-0.781,0.781-2.047,0-2.828L35,16.172	C34.219,15.391,32.953,15.391,32.172,16.172z"
                    opacity=".05"
                  ></path>
                  <path
                    d="M20.939,33.061l-8-8c-0.586-0.586-0.586-1.536,0-2.121l1.414-1.414c0.586-0.586,1.536-0.586,2.121,0	L22,27.051l10.525-10.525c0.586-0.586,1.536-0.586,2.121,0l1.414,1.414c0.586,0.586,0.586,1.536,0,2.121l-13,13	C22.475,33.646,21.525,33.646,20.939,33.061z"
                    opacity=".07"
                  ></path>
                  <path
                    fill="#fff"
                    d="M21.293,32.707l-8-8c-0.391-0.391-0.391-1.024,0-1.414l1.414-1.414c0.391-0.391,1.024-0.391,1.414,0	L22,27.758l10.879-10.879c0.391-0.391,1.024-0.391,1.414,0l1.414,1.414c0.391,0.391,0.391,1.024,0,1.414l-13,13	C22.317,33.098,21.683,33.098,21.293,32.707z"
                  ></path>
                </svg>
              </Typography>
              <Typography
                id="delete-modal-title"
                sx={{ textAlign: "center" }}
                variant="h4"
                component="h2"
              >
                Application Submitted
              </Typography>
              <Grid container mt={3} justifyContent={"center"} gap={2}>
                <Button
                  className="custombutton"
                  variant="contained"
                  color="success"
                  sx={{ width: "90px" }}
                  onClick={() => {
                    setOpenModal(false);
                  }}
                >
                  Continue
                </Button>
              </Grid>
            </Box>
          </Card>
        </Modal>
      )}
      {openTimeSheetPopup && (
        <JobtTimeSheet
          openTimeSheetPopup={openTimeSheetPopup}
          data={selectedCard}
          handleCancel={() => handleCancel(false)}
          onSuccess={() => {
            if (onSaved) onSaved(); // ← this triggers refetch in MyJobs
          }}
        />
      )}
    </>
  );
}
